<template>
	<div id="agent">
		<div class="agent_banner" v-cloak></div>

		<!-- agent_mode -->
		<div id="agent_mode">
			<div class="title">业务模式</div>
			<div class="subhead">10年开发经验+优秀技术团队，为您提供最合适的方案设计</div>
			<div class="mode_lists">
				<div class="mode_list" v-for="item in modelists">
					<div class="mode_listImg"><img :src="item.img"></div>
					<div class="mode_listImgHover">
						<div>{{item.introText}}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="agent_support">
			<div class="title">合作支持</div>
			<div class="subhead">秉承“合作共赢、耕耘收获”的理念，以与合作伙伴实现双赢为宗旨，积极贯彻合作、开放、共赢的渠道策略</div>
			<div class="agent_supportLists">
				<div v-for="(item,index) in supports" class="agent_supportList" :style="{backgroundImage:'url(' + item.background + ')'}">
					<img :src="item.icon">
					<div class="supportTitle">{{item.title}}</div>
					<div class="supportText">{{item.text}}</div>
				</div>
			</div>
		</div>
		<div class="agent_info">
			浙江安宣信息技术有限公司 <br> 地址：杭州市西湖区西园八路11号一期D座506-507 <br> 邮编：310000 <br> 官网：http://www.ax168.com/ <br> 邮箱：zjax@ansuw.com <br> 全国统一客服热线：0571-87357305
		</div>
		<!-- <div class="agent_channel">
			<div class="title">合作通道</div>
			<div class="agent_channelLists">
				<div class="channelList">
					<div class="describe">单位名称</div>
					<input type="text" v-model="channel.organization_name">
				</div>
				<div class="channelList">
					<div class="describe">负责人姓名</div>
					<input type="text" v-model="channel.chargeperson_name">
				</div>
				<div class="channelList">
					<div class="describe">负责人手机</div>
					<input type="text" v-model="channel.chargeperson_phone">
				</div>
				<div class="channelList">
					<div class="describe">负责人座机</div>
					<input type="text" v-model="channel.chargeperson_tele">
				</div>
				<div class="channelList">
					<div class="describe">负责人电子邮件</div>
					<input type="text" v-model="channel.chargeperson_email">
				</div>
				<div class="channelList">
					<div class="describe">单位所在地</div>
					<input type="text" v-model="channel.organization_address">
				</div>
				<div class="channelList">
					<div class="describe">单位网址</div>
					<input type="text" v-model="channel.organization_web">
				</div>
				<div class="channelList">
					<div class="describe">
						<div class="describe_title">公司描述</div>
						<div class="describe_subhead">公司规模、主营业务简单描述</div>
					</div>
					<textarea cols="30" rows="10" v-model="channel.organization_describe"></textarea>
				</div>
			</div>
			<div class="channelSubmit" @click="submit">提交</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/agent'
					},
					{
						name: 'agent',
						content: '代理合作。业务模式、合作支持'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				Seo: '关于我们,http://www.ax168.com/about',
				supports: [{
						title: '业务支持',
						text: '专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。',
						background: 'http://img.anxuan360.com/Fq_dvzH6cFolrf2UsU1kWS41kZpg',
						icon: 'http://img.anxuan360.com/FtasxZlh7spW-8SDRij5KCkH_kui',
					},
					{
						title: '培训支持',
						text: '为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。',
						background: 'http://img.anxuan360.com/Fh4dNUJurfJXrI0VdGJz2BZPSKLw',
						icon: 'http://img.anxuan360.com/FrLvHamf-_BZefoMD17GyBbm6iJ3',
					},
					{
						title: '专业技术支持',
						text: '专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。',
						background: 'http://img.anxuan360.com/FgcAUCEvkiTOf7pXFXvJ8uA-LrvM',
						icon: 'http://img.anxuan360.com/FghddmA01lkYDvCLCjG-GkxCYV_B',
					},
				],
				channel: {
					organization_name: '', //单位名称
					chargeperson_name: '', //负责人姓名
					chargeperson_phone: '', //负责人手机
					chargeperson_tele: '', //负责人座机
					chargeperson_email: '', //负责人电子邮件
					organization_address: '', //单位所在地
					organization_web: '', //单位网址
					organization_describe: '', //公司描述
				},
				modelists: [{
						img: 'http://img.anxuan360.com/Fm5JaxjDwzQnjFWIY8dyDT248gXc',
						introText: '模式1：秤+银行聚合码    适用于农贸市场 效率高，易操作。支持微信，支付宝等多种扫码支付方式。支持到帐语音播报和小票打印功能。'
					},
					{
						img: 'http://img.anxuan360.com/FqxTP7fpuCWntcx0nno9KjZcAkhU',
						introText: '模式2：结算中心+POS机 适用于统一收银的批发市场，收款方式更多样化，对市场管理要求较高。'
					},
					{
						img: 'http://img.anxuan360.com/FofoV67hdQGgfFT-2NvAnS7WUvHP',
						introText: '模式3：为客户量身定制更多模式。公司专业从事产品追溯，智慧支付行业多年，不断研发新的产品，采用最新制造工艺，推出多款系列产品，可以针对不同地区市场差异，因地制宜。'
					},
				],
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		methods: {
			submit: function() {
				this.$parent.toast('提交成功');
				for(var i in this.channel) {
					this.channel[i] = '';
				}
			}
		},
		components: {

		}
	}
</script>

<style>
	@import url('../css/agent.css');
	[v-cloak] {
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/agent.vue